export default "__VITE_ASSET__DsH9NxAI__"